let previousValueClubs = null;
let previousValueMembershipTypes = null;

const getClubsSelect = function() {
  return $('#membership_sportingClub');
};

const getMembershipTypeSelect = function() {
  return $('#membership_membershipType');
};

const removeChoices = function() {
  previousValueClubs = getClubsSelect().val();
  previousValueMembershipTypes = getMembershipTypeSelect().val();

  getClubsSelect().find('option:not([value=""])').remove();
  getMembershipTypeSelect().find('option:not([value=""])').remove();
};

const fillChoicesForClubs = function(data) {
  const $select = getClubsSelect();
  $select.attr('disabled', true);
  for (let i in data) {
    let club = data[i];
    $select.removeAttr('disabled');
    $select.append(
      $('<option>').attr('value', club.id).text(club.name)
    );
  }

  if (previousValueClubs) {
    $select.find('[value="'+previousValueClubs+'"]').attr('selected', true);
  }
};

const fillChoicesForMembershipTypes = function(data) {
  const $select = getMembershipTypeSelect();
  $select.attr('disabled', true);
  for (let i in data) {
    let mtype = data[i];
    $select.removeAttr('disabled');
    $select.append(
      $('<option>').attr('value', mtype.id).text(mtype.name)
    );
  }

  if (previousValueMembershipTypes) {
    $select.find('[value="'+previousValueMembershipTypes+'"]').attr('selected', true);
  }
};

export default {
  wait() {
    removeChoices();
  },

  done(data) {
    fillChoicesForClubs(data.clubs);
    fillChoicesForMembershipTypes(data.membershipTypes);
  },

  fail() {
    removeChoices();
  }
}



// WEBPACK FOOTER //
// ./assets/js/component/ajax/membership-federation-select.js